<template>
  <v-card height="auto">
    <vue-card-title
      :title="
        actionData && actionData.slug ? 'Update Document' : 'Create Document'
      "
      :subtitle="
        actionData && actionData.slug
          ? 'Here you can update the existing document.'
          : 'Here you can create new document.'
      "
      :icon="$getIcon('mdiFileDocumentOutline')"
      closable
      dark
      @close="$emit('close')"
    ></vue-card-title>
    <v-divider></v-divider>
    <v-card-text class="py-4 scrollbar-md">
      <v-row no-gutters class="pa-0 ma-0">
        <v-col v-if="formValidator.getError('non_field_errors')">
          <v-alert shaped outlined text type="error">
            {{ formValidator.getError("non_field_errors") }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" cols="12">
          <v-text-field
            v-model="formValues.title"
            label="Title *"
            counter="50"
            :error-messages="formValidator.getError('title')"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
          ></v-text-field>
        </v-col>
        <v-col md="6" cols="12">
          <v-select
            v-model="formValues.type"
            :items="categoryOptions"
            label="Category *"
            :prepend-inner-icon="$getIcon('mdiInformationOutline')"
            :error-messages="formValidator.getError('type')"
          ></v-select>
        </v-col>
        <v-col md="6" cols="12">
          <file-upload
            :label="'Upload File *'"
            v-model="fileName"
            @update="formValues.attachment = $event"
            :error-messages="formValidator.getError('attachment')"
          ></file-upload>
        </v-col>
        <v-col md="6" cols="12">
          <v-checkbox
            v-model="formValues.is_archived"
            label="Is Archived"
          ></v-checkbox>
        </v-col>
        <v-col md="12" cols="12">
          <v-textarea
            v-model="formValues.description"
            label="Description"
            counter="600"
            rows="3"
            :error-messages="formValidator.getError('description')"
            :prependInnerIcon="$getIcon('mdiInformationOutline')"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-row no-gutters>
        <v-col class="text-right">
          <v-btn text @click="$emit('close')" class="text-capitalize">
            Cancel
          </v-btn>
          <v-btn
            depressed
            color="indigo"
            class="white--text text-capitalize"
            :disabled="loading"
            @click="submit()"
          >
            {{ actionData && actionData.slug ? "Update" : "Create" }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
import FileUpload from "@/components/common/form_utils/FileUpload";
import { jsonToFormData } from "@/utils/jsontoformdata";
export default {
  jsonToFormData,
  components: { FileUpload },
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      categoryOptions: [
        "Sales Proposal",
        "Sales Letter",
        "Email Template",
        "Offer Letter",
        "Discount Letter",
        "Invoice"
      ],
      formValues: {
        is_archived: false
      },
      loading: false,
      formValidator: new FormValidator(),
      fileName: ""
    };
  },
  created() {
    if (this.actionData && this.actionData.slug) {
      this.getData();
    }
  },
  methods: {
    getFileName() {
      if (this.formValues.attachment) {
        const attachmentUrl = this.formValues.attachment.substr(0);
        const fileName = attachmentUrl.split("/").pop();
        return fileName;
      } else return "";
    },
    getData() {
      this.loading = true;
      let endpoint = `/api/v1/org/${this.$store.state.shell.currentOrganizationId}/documents/${this.actionData.slug}/`;
      this.$axios
        .$get(endpoint)
        .then(response => {
          this.formValues = response;
          this.fileName = this.getFileName();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit() {
      this.actionData && this.actionData.slug
        ? this.updateForm()
        : this.createForm();
    },
    createFormValues() {
      if (!(this.formValues.attachment instanceof File)) {
        delete this.formValues.attachment;
      }
      return this.$options.jsonToFormData(this.formValues);
    },
    createForm() {
      this.loading = true;
      let endpoint = `/api/v1/org/${this.$store.state.shell.currentOrganizationId}/documents/`;
      this.$axios
        .$post(endpoint, this.createFormValues())
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully created Document.`,
            color: "green"
          });
          this.$emit("create");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateForm() {
      this.loading = true;
      let endpoint = `/api/v1/org/${this.$store.state.shell.currentOrganizationId}/documents/${this.actionData.slug}/`;
      this.$axios
        .$patch(endpoint, this.createFormValues())
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully updated Document.`,
            color: "green"
          });
          this.$emit("update");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
